import React from "react";
import { string } from "prop-types";

const ErrorIcon = ({ className = "" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12.8 17.6H11.2V16H12.8V17.6ZM12.8 13.6H11.2V6.4H12.8V13.6Z"
      fill="#BA0000"
    />
  </svg>
);

ErrorIcon.propTypes = {
  className: string,
};

export default ErrorIcon;
